import { render, staticRenderFns } from "./addposition.vue?vue&type=template&id=ce2ba838&scoped=true"
import script from "./addposition.vue?vue&type=script&lang=js"
export * from "./addposition.vue?vue&type=script&lang=js"
import style0 from "./addposition.vue?vue&type=style&index=0&id=ce2ba838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2ba838",
  null
  
)

export default component.exports